module.exports = __webpack_public_path__ + "img/eye-slash.88743de8.svg";